import { Stack } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Wrapper = styled(Stack)`
  padding: ${(p) => p.theme.spacing(1.5, 3, 1.5, 1.5)};
  background: ${(p) => p.theme.palette.common.white};
  border-top: 1px solid ${(p) => p.theme.palette.grey[300]};
`;
